import { ApiService } from './../../../core/services/api.service';
import { RegistrosService } from './registros.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, effect, Injector, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { RegistrosInterface } from 'app/modules/global-components/tabla-registros/registros-interface';
import { TablaRegistrosComponent } from 'app/modules/global-components/tabla-registros/tabla-registros.component';
import { Tipologia } from 'app/modules/models/tipologia.model';
import { environment } from 'enviroments/environment';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AgregarEditarRegistroComponent } from './agregar-editar-registro/agregar-editar-registro';
import { CarreraModel, ListadoCarrerasDTO } from 'app/modules/models/carreras.model';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ControlAccesoDirective } from 'app/shared/directives/control-acceso.directive';
import { ActivatedRoute } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { ResponseInterface } from 'app/modules/models/response.model';
import { BitacoraInformesComponent } from './historial-informes/bitacora-informes.component';
import { DialogConfirmComponent } from 'app/modules/global-components/dialog-confirm.component.ts/dialog-confirm.component';
import { CargarPlantillaComponent } from './cargar-plantilla/cargar-plantilla.component';
import { UtilsService } from 'app/modules/utils.service';


@Component({
    selector: 'listado-registros',
    templateUrl: 'listado-registros.component.html',
    standalone: true,
    imports:[
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        MatPaginatorModule,
        MatIconModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatTabsModule,

        ControlAccesoDirective,
        TablaRegistrosComponent
    ]
})

export class ListadoRegistrosComponent implements OnInit {
    registros: RegistrosInterface[] = [];
    registrosFiltrados: RegistrosInterface[] = [];

    ciclos: Tipologia[] = [];
    profesionales: Tipologia[] = [];
    tiposInstituto: Tipologia[] = [];
    areasCarrera: Tipologia[] = [];
    subareasCarrera: Tipologia[] = [];
    orientacionesBasico: Tipologia[] = [];
    orientacionesOcupacionalesBasico: Tipologia[] = [];

    tabIndex = 0;
    cicloSeleccionado: number = 0;
    cicloBasico: number | null = null;
    profesionalSeleccionado: number | string = 0;
    tipoInstitutoSeleccionado: number | string = 0;
    areaSeleccionada: number | string = 0;
    subareaSeleccionada: number | string = 0;
    orientacionSeleccionada: number | string = 0;
    orientacionOcupacionalSeleccionada: number | string = 0;
    descargandoInforme = false;
    mensajeDescarga = 'Generando informe, por favor espere...';
    cargandoRegistros = false;
    @ViewChild('descargaDialog') descargaDialog?: TemplateRef<any>;

    cicloDiversificado: number = environment.TIPOLOGIA_ID_CICLO_DIVERSIFICADO

    private _paginator?: MatPaginator;
    private _paginatorSub?: Subscription;
    public totalRegistros: number = 0;
    public pageSize: number = 20;
    private _injector: Injector;
    private _textoBusquedaRuta: string | null = null;

    constructor(
        private _registrosService: RegistrosService,
        private _dialog: MatDialog,
        private _route: ActivatedRoute,
        injector: Injector,
        private _apiService: ApiService,
        private _utilsService: UtilsService

    )
    {
        this._injector = injector;
        this._textoBusquedaRuta = this._route.snapshot.queryParamMap.get('texto');
        let params = this.buildParams(0, this.pageSize)
        this.getCiclos();
        this.getTipoProfesion();
        this.getTipoInstituto();

        this.loadListado(params);
    }

    ngOnInit() {
        this.registrosFiltrados = [...this.registros];

        this._route.queryParamMap.subscribe((params) => {
            const texto = params.get('texto');
            if (texto !== this._textoBusquedaRuta) {
                this._textoBusquedaRuta = texto;
                this.recargarListado();
            }
        });

        // Efecto reactivo con Signals para recargar listado al detectar cambios en registros
        effect(() => {
            // Leer el signal para registrar la dependencia
            this._registrosService.cambiosRegistrosSignal();
            this.recargarListado();
        }, { injector: this._injector });
    }

    @ViewChild(MatPaginator)
    set paginator(value: MatPaginator | undefined) {
        if (this._paginator === value) {
            return;
        }
        this._paginator = value;
        this._paginatorSub?.unsubscribe();
        if (!value) {
            return;
        }
        // subscribe for paginator changes
        this._paginatorSub = value.page.subscribe(() => {
                const pageIndex =  value.pageIndex

                let inicio = 0
                let max = this.pageSize
                if (pageIndex == 0 ) {
                    inicio = 0
                    max = this.pageSize
                }
                else {
                    inicio =  (pageIndex * this.pageSize)
                    max =  (inicio + this.pageSize)
                }

                let params = this.buildParams(inicio, max)

                this.loadListado(params);
            });
    }

    filtrar(): void {

        let params = this.buildParams(0, this.pageSize)

        this.loadListado(params);
    }

    onTabChange(index: number): void {
        this.tabIndex = index;
        const ciclo = index === 1 ? this.cicloDiversificado : (this.cicloBasico ?? 0);
        if (this.cicloSeleccionado === ciclo) {
            return;
        }
        this.cicloSeleccionado = ciclo;
        this.areaSeleccionada = 0;
        this.subareaSeleccionada = 0;
        this.orientacionSeleccionada = 0;
        this.orientacionOcupacionalSeleccionada = 0;
        this.cargarAreasPorCiclo();
        this.cargarOrientacionesBasico();
        if (this.cicloSeleccionado === this.cicloDiversificado) {
            this.tipoInstitutoSeleccionado = 0;
        }
        if (this._paginator) {
            this._paginator.firstPage();
        }
        this.filtrar();
    }

    private getCiclos(): void {
        this._registrosService.getTipologias(environment.TIPOLOGIA_ID_CICLO)
        .then((response:Tipologia)=>{
            this.ciclos = response.tipologias
            const cicloBasico = this.ciclos.find((c) => c.tipologiaId !== this.cicloDiversificado);
            this.cicloBasico = cicloBasico?.tipologiaId ?? null;
            if (this.cicloSeleccionado === 0 && this.cicloBasico) {
                this.cicloSeleccionado = this.cicloBasico;
                this.cargarAreasPorCiclo();
                this.cargarOrientacionesBasico();
                this.recargarListado();
            }
        })
    }

    private getTipoProfesion(): void {
        this._registrosService.getTipologias(environment.TIPOLOGIA_ID_TIPO_PROFESIONAL)
        .then((response:Tipologia)=>{
            this.profesionales = response.tipologias
        })
    }

    private getTipoInstituto(): void {
        this._registrosService.getTipologias(environment.TIPOLOGIA_ID_TIPO_MODALIDAD)
        .then((response:Tipologia)=>{
            this.tiposInstituto = response.tipologias
        })
    }

    private cargarAreasPorCiclo(): void {
        if (!this.cicloSeleccionado) {
            this.areasCarrera = [];
            this.subareasCarrera = [];
            this.subareaSeleccionada = 0;
            return;
        }
        const tipologiaId = this.cicloSeleccionado === this.cicloDiversificado
            ? environment.TIPOLOGIA_ID_AREA_CARRERA_DIVERSIFICADO
            : environment.TIPOLOGIA_ID_AREA_CARRERA_BASICO;
        this._registrosService.getTipologias(tipologiaId)
            .then((response: Tipologia) => {
                this.areasCarrera = response.tipologias || [];
                if (!this.areasCarrera.some((area) => area.descripcion === this.areaSeleccionada)) {
                    this.areaSeleccionada = 0;
                }
                if (this.cicloSeleccionado === this.cicloDiversificado) {
                    this.cargarSubareasPorArea();
                } else {
                    this.subareasCarrera = [];
                    this.subareaSeleccionada = 0;
                }
            })
            .catch(() => {
                this.areasCarrera = [];
                this.subareasCarrera = [];
                this.areaSeleccionada = 0;
                this.subareaSeleccionada = 0;
            });
    }

    private cargarOrientacionesBasico(): void {
        if (this.cicloSeleccionado === this.cicloDiversificado) {
            this.orientacionesBasico = [];
            this.orientacionesOcupacionalesBasico = [];
            this.orientacionSeleccionada = 0;
            this.orientacionOcupacionalSeleccionada = 0;
            return;
        }
        this._registrosService.getTipologias(environment.TIPOLOGIA_ID_ORIENTACION_BASICO)
            .then((response: Tipologia) => {
                this.orientacionesBasico = response.tipologias || [];
                if (!this.orientacionesBasico.some((o) => o.descripcion === this.orientacionSeleccionada)) {
                    this.orientacionSeleccionada = 0;
                }
                this.cargarOrientacionesOcupacionales();
            })
            .catch(() => {
                this.orientacionesBasico = [];
                this.orientacionesOcupacionalesBasico = [];
                this.orientacionSeleccionada = 0;
                this.orientacionOcupacionalSeleccionada = 0;
            });
    }

    onOrientacionChange(): void {
        this.orientacionOcupacionalSeleccionada = 0;
        this.cargarOrientacionesOcupacionales();
        this.filtrar();
    }

    private cargarOrientacionesOcupacionales(): void {
        if (this.cicloSeleccionado === this.cicloDiversificado) {
            this.orientacionesOcupacionalesBasico = [];
            this.orientacionOcupacionalSeleccionada = 0;
            return;
        }
        const selectedOrientacion = this.getSelectedOrientacion();
        const tipologiaId = selectedOrientacion?.tipologiaId ?? 0;
        if (!tipologiaId) {
            this.orientacionesOcupacionalesBasico = [];
            this.orientacionOcupacionalSeleccionada = 0;
            return;
        }
        this._registrosService.getTipologias(tipologiaId)
            .then((response: Tipologia) => {
                this.orientacionesOcupacionalesBasico = response.tipologias || [];
                if (!this.orientacionesOcupacionalesBasico.some((o) => o.descripcion === this.orientacionOcupacionalSeleccionada)) {
                    this.orientacionOcupacionalSeleccionada = 0;
                }
            })
            .catch(() => {
                this.orientacionesOcupacionalesBasico = [];
                this.orientacionOcupacionalSeleccionada = 0;
            });
    }

    private getSelectedOrientacion(): Tipologia | null {
        if (!this.orientacionSeleccionada || this.orientacionSeleccionada === 0) {
            return null;
        }
        if (typeof this.orientacionSeleccionada === 'number') {
            return this.orientacionesBasico.find((o) => o.tipologiaId === this.orientacionSeleccionada) || null;
        }
        return this.orientacionesBasico.find((o) => o.descripcion === this.orientacionSeleccionada) || null;
    }

    onAreaChange(): void {
        this.subareaSeleccionada = 0;
        if (this.cicloSeleccionado === this.cicloDiversificado) {
            this.cargarSubareasPorArea();
        } else {
            this.subareasCarrera = [];
        }
        this.filtrar();
    }

    private cargarSubareasPorArea(): void {
        if (this.cicloSeleccionado !== this.cicloDiversificado) {
            this.subareasCarrera = [];
            this.subareaSeleccionada = 0;
            return;
        }
        const selectedArea = this.getSelectedArea();
        const tipologiaId = selectedArea?.tipologiaId ?? 0;
        if (!tipologiaId) {
            this.subareasCarrera = [];
            this.subareaSeleccionada = 0;
            return;
        }
        this._registrosService.getTipologias(tipologiaId)
            .then((response: Tipologia) => {
                this.subareasCarrera = response.tipologias || [];
                if (!this.subareasCarrera.some((subarea) => subarea.descripcion === this.subareaSeleccionada)) {
                    this.subareaSeleccionada = 0;
                }
            })
            .catch(() => {
                this.subareasCarrera = [];
                this.subareaSeleccionada = 0;
            });
    }

    private getSelectedArea(): Tipologia | null {
        if (!this.areaSeleccionada || this.areaSeleccionada === 0) {
            return null;
        }
        if (typeof this.areaSeleccionada === 'number') {
            return this.areasCarrera.find((area) => area.tipologiaId === this.areaSeleccionada) || null;
        }
        return this.areasCarrera.find((area) => area.descripcion === this.areaSeleccionada) || null;
    }

    aregar(): void {

        const carrera = new CarreraModel()
        this._dialog.open(AgregarEditarRegistroComponent, {
            width: '75%',
            data: carrera
        });
    }

    private buildParams(inicio: number, max: number): any {
        const params: any = { inicio, max };

        const ciclo = Number(this.cicloSeleccionado || 0);
        const prof = this.profesionalSeleccionado || 0;
        const tipoInst = this.tipoInstitutoSeleccionado || 0;
        const area = this.areaSeleccionada || 0;
        const subarea = this.subareaSeleccionada || 0;
        const orientacion = this.orientacionSeleccionada || 0;
        const orientacionOcupacional = this.orientacionOcupacionalSeleccionada || 0;

        if (!Number.isNaN(ciclo) && ciclo !== 0) {
            params.ciclo = ciclo;
        }

        if (prof !== 0) {
            params.profesional = prof;
        }

        if (this.cicloSeleccionado !== this.cicloDiversificado && tipoInst !== 0) {
            params.tipoInstituto = tipoInst;
        }

        if (area !== 0) {
            params.area = area;
        }

        if (this.cicloSeleccionado === this.cicloDiversificado && subarea !== 0) {
            params.subarea = subarea;
        }

        if (this.cicloSeleccionado !== this.cicloDiversificado && orientacion !== 0) {
            params.orientacion = orientacion;
        }

        if (this.cicloSeleccionado !== this.cicloDiversificado && orientacionOcupacional !== 0) {
            params.orientacionOcupacional = orientacionOcupacional;
        }

        if (this._textoBusquedaRuta) {
            params.search = this._textoBusquedaRuta;
        }

        return params;
    }

    private recargarListado(): void {
        // se mantiene la paginación actual si existe, de lo contrario se reinicia en 0
        const pageIndex = this._paginator ? this._paginator.pageIndex : 0;
        let inicio = 0;
        let max = this.pageSize;
        if (pageIndex && pageIndex > 0) {
            inicio = pageIndex * this.pageSize;
            max = inicio + this.pageSize;
        }

        const params = this.buildParams(inicio, max);
        this.loadListado(params);
    }

    private loadListado(params: any): void {
        this.cargandoRegistros = true;
        this._registrosService.getListadoCarreras(params)
            .then((data: ListadoCarrerasDTO) => {
                this.registrosFiltrados = [...data.data as unknown as RegistrosInterface[]];
                this.totalRegistros = data.total;
            })
            .catch((error) => {
                console.error('Error al cargar registros', error);
            })
            .finally(() => {
                this.cargandoRegistros = false;
            });
    }

    async descargarInforme(): Promise<void> {
        this.descargandoInforme = true;
        this.mensajeDescarga = 'Generando informe, por favor espere...';
        const dialogRef = this.descargaDialog
            ? this._dialog.open(this.descargaDialog, { disableClose: true, panelClass: 'w-96' })
            : null;
        try {
            const response = await this._registrosService.descargarInforme() as ResponseInterface;

            if (response.isSuccess && response.data?.documentoUrl) {
            const url = response.data.documentoUrl;

            window.open(url, "_blank")

            } else {
            this._apiService.showErrorMessage('No se pudo obtener la URL del informe');
            }
        } catch (error) {
            console.error('Error al descargar el informe', error);
        } finally {
            this.descargandoInforme = false;
            dialogRef?.close();
        }
    }

    async descargarReporte(){
        this.descargandoInforme = true;
        this.mensajeDescarga = 'Generando reporte de registros, por favor espere...';
        const dialogRef = this.descargaDialog
            ? this._dialog.open(this.descargaDialog, { disableClose: true, panelClass: 'w-96' })
            : null;
        try {
            const response = await this._registrosService.descargarReporteDeRegistros() as Blob;

            if (response instanceof Blob && response.size > 0) {
                this._utilsService.downloadFile(response, 'reporte-registros', 'xlsx');
            } else {
                this._apiService.showErrorMessage('No se pudo descargar el reporte de registros');
            }
        } catch (error) {
            console.error('Error al descargar el reporte de registros', error);
        } finally {
            this.descargandoInforme = false;
            dialogRef?.close();
        }
    }

    verHistorialInformes(): void {
        this._dialog.open(BitacoraInformesComponent, {
            panelClass: ['md:w-6/12', 'w-full'],
            height: '85%'
        });
    }

    abrirCargarPlantilla(): void {
        this._dialog.open(CargarPlantillaComponent, {
            panelClass: ['md:w-6/12', 'w-full'],
            disableClose: true
        });
    }

    eliminarRegistro(registro: RegistrosInterface): void {
        const dialogRef = this._dialog.open(DialogConfirmComponent, {
            panelClass: ['md:w-4/12', 'w-full'],
            data: {
                message: `Está a punto de eliminar el registro ${registro.carrera}. ¿Desea continuar?`,
                inputPlaceholder: 'Motivo de eliminación'
            },
            disableClose: true
        });

        dialogRef.afterClosed().toPromise()
            .then(async (result: { confirmed: boolean; inputValue: string }) => {
                if (result?.confirmed) {
                    try {
                        const response = await this._registrosService.eliminarRegistro(registro.carreraUuid, result.inputValue) as ResponseInterface;
                        this._apiService.showSuccessMessage(response.message ?? 'Registro se eliminó correctamente');
                        this.recargarListado();
                    } catch (error) {
                        console.error('Error al eliminar el registro', error);
                        this._apiService.showErrorMessage('No se pudo eliminar el registro');
                    }
                }
            })
            .catch(error => {
                console.error('Error al cerrar el diálogo de eliminación', error);
            });
    }

    publicarRegistro(registro: RegistrosInterface): void {
        const message = `Está a punto de publicar el registro ${registro.carrera}. ¿Desea continuar?`;

        this._apiService.open_confirm_dialog(message).subscribe((confirmado) => {
            if (!confirmado) { return; }

            this._registrosService.publicarRegistro(registro.carreraUuid)
                .then((response: ResponseInterface) => {
                    this._apiService.showSuccessMessage(response.message ?? 'Registro publicado correctamente');
                    this.recargarListado();
                })
                .catch(error => {
                    console.error('Error al publicar el registro', error);
                    this._apiService.showErrorMessage('No se pudo publicar el registro');
                });
        });
    }

}
